import { Fragment, useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { Paginator } from 'primereact/paginator';

import { InvoiceService } from '../InvoiceService';
import { FormulaTypeService } from '../../he-thong/cau-hinh-hoa-don/FormulaTypeService';
import { ProductService } from '../../danh-muc/hang-hoa-dich-vu/ProductService';
import { UnitService } from '../../danh-muc/don-vi-tinh/UnitService';

import { InvoiceField } from './Initial';

import { useCellEditing } from '../../../shared/hooks/CellEditing';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { FormatDisplay } from '../../../shared/format';

let onewayCalc = {};

export const ChiTietHangHoa = (props) => {

  const { invoiceGroupSetting, formulas, item, taxes, defaultTax, patchItem, getFormat, registerInvoiceId } = props;

  const { invoiceDetail, currencyCode } = item;

  const code = '05';

  const [formulaTypes, setFormulaTypes] = useState(null);

  const [columns, setColumns] = useState([]);
  const [blankItem, setBlankItem] = useState({});

  const [products, setProducts] = useState([]);
  const [units, setUnits] = useState([]);

  const [addButtonRowData, setAddButtonRowData] = useState(null);
  const [addButtonColumn, setAddButtonColumn] = useState(null);

  const [taxOptions, setTaxOptions] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);
  const [virtualItems, setVirtualItems] = useState([]);

  useEffect(() => {
    FormulaTypeService.getList({}).then(({ items }) => {
      const _formulaTypes = [];
      items.forEach(item => {
        _formulaTypes.push({ value: item.code, label: item.name });
      });
      setFormulaTypes(_formulaTypes);
    });
    UnitService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({ items }) => {
      const _units = [];
      items.forEach(item => {
        _units.push({ value: item.id, label: item.name });
      });
      setUnits(_units);
    });
  }, []);

  useEffect(() => {
    if (taxes) {
      const _taxOptions = [];
      taxes.forEach(tax => {
        _taxOptions.push({ value: tax.id, label: tax.name });
      });
      setTaxOptions(_taxOptions);
    }
  }, [taxes]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  }

  useEffect(() => {
    if (invoiceDetail?.length === 0) {
      setVirtualItems([Object.assign({ _id: `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}` }, blankItem)]);

    }
    if (invoiceDetail && invoiceDetail.length > 50) {
      setTotalRecords(invoiceDetail.length);
      setVirtualItems(invoiceDetail.slice(first, first + rows));
    } else {
      setVirtualItems(invoiceDetail);
      setTotalRecords(0);
    }
  }, [invoiceDetail, first, rows]);

  const { render: renderDialogCrupProduct, create: createProduct } = useDialogCrup({
    header: 'Hàng hóa, dịch vụ',
    dataKey: 'id',
    width: '60rem',
    fields: [
      { field: 'code', header: 'Mã hàng hóa', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-12' },
      { field: 'name', header: 'Tên hàng hóa', required: true, InputTextProps: { maxLength: 500 }, className: 'md:col-12' },
      { field: 'unitId', header: 'Đơn vị tính', type: 'Dropdown', DropdownProps: { options: units, filter: true }, className: 'md:col-6' },
      { field: 'taxId', header: 'Thuế suất', type: 'Dropdown', DropdownProps: { options: taxOptions, filter: true }, className: 'md:col-6' },
      { field: 'price', header: 'Giá bán', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 2 }, className: 'md:col-12' }
    ],
    createItem: (item) => {
      return ProductService.create(item);
    },
    refreshLazyData: (data) => {
      if (data) {
        onCellChange(addButtonRowData, addButtonColumn, data);
      }
    }
  });

  const { render: renderDialogCrupUnit, create: createUnit } = useDialogCrup({
    header: 'Đơn vị tính',
    dataKey: 'id',
    width: '40rem',
    fields: [
      { field: 'code', header: 'Mã đơn vị tính', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-12' },
      { field: 'name', header: 'Tên đơn vị tính', InputTextProps: { maxLength: 50 }, className: 'md:col-12' }
    ],
    createItem: (item) => {
      return UnitService.create(item);
    },
    refreshLazyData: (data) => {
      if (data) {
        onCellChange(addButtonRowData, addButtonColumn, { value: data.name, label: data.name });
      }
    }
  });

  useEffect(() => {
    if (invoiceGroupSetting && invoiceGroupSetting[code] && invoiceGroupSetting[code].settings && formulaTypes && taxes.length) {
      const _columns: any = [
        { field: 'isShowOrder', header: '', dataType: 'checkbox', editable: true, style: { minWidth: '40px', maxWidth: '40px' }, rowReorder: true }
      ];
      const _blankItem: any = { isShowOrder: true, formulaType: formulaTypes[0].value };
      for (const setting of invoiceGroupSetting[code].settings) {

        const field = `${setting.fieldName}`;
        const columnWidth = setting.lableWidth + 'px';

        let dataType;
        switch (setting.dataType) {
          case 'int32':
            dataType = 'number';
            _blankItem[field] = null;
            break;
          default:
            _blankItem[field] = '';
        }

        let _column;
        switch (field) {
          case InvoiceField.OrdinalNumber:
            _column = {
              field, header: setting.lable, dataType, editable: setting.readOnly,
              style: { minWidth: columnWidth, maxWidth: columnWidth }, className: 'text-center'
            };
            break;
          case InvoiceField.ProductCode:
            _column = {
              field, header: setting.lable, dataType: 'autocomplete', editable: setting.readOnly, style: { minWidth: columnWidth, maxWidth: columnWidth },
              inputProps: {
                field: 'code',
                suggestions: products,
                completeMethod: (event) => {
                  ProductService.getList({ code: event.query }).then(({ items }) => {
                    setProducts(items);
                  });
                }, itemTemplate: (item) => {
                  return `${item.code} - ${item.name}`;
                }
              }, addButton: true, onAddButtonClick: (rowData, column) => {
                setAddButtonRowData(rowData);
                setAddButtonColumn(column);
                createProduct();
              }
            };
            break;
          case InvoiceField.unitCode:
            _column = {
              field, header: setting.lable, dataType: 'autocomplete', editable: setting.readOnly, style: { minWidth: columnWidth, maxWidth: columnWidth },
              inputProps: {
                field: 'label',
                suggestions: units,
                completeMethod: (event) => {
                  UnitService.getList({ name: event.query }).then(({ items }) => {
                    const _units = [];
                    items.forEach(item => {
                      _units.push({ value: item.name, label: item.name });
                    });
                    setUnits(_units);
                  });
                }, itemTemplate: (item) => {
                  return item.label;
                }
              }, addButton: true, onAddButtonClick: (rowData, column) => {
                setAddButtonRowData(rowData);
                setAddButtonColumn(column);
                createUnit();
              }
            };
            break;
          case InvoiceField.ProductName:
            _column = { field, header: setting.lable, dataType, editable: setting.readOnly, style: { minWidth: columnWidth } };
            break;
          case InvoiceField.vATCode:
            _column = {
              field, header: setting.lable, dataType: 'dropdown', editable: true, style: { minWidth: columnWidth, maxWidth: columnWidth },
              inputProps: { options: taxes, optionLabel: 'name' }
            };
            break;
          case InvoiceField.property:
            _column = {
              field, header: setting.lable, dataType: 'dropdown', editable: true, style: { minWidth: columnWidth, maxWidth: columnWidth },
              inputProps: { options: InvoiceService.itemProperties, }
            };
            break;
          case InvoiceField.isHiddenReport:
            _column = {
              field, header: setting.lable, dataType: 'checkbox', editable: true, style: { minWidth: columnWidth, maxWidth: columnWidth }
            };
            _blankItem[field] = false;
            break;
          default:
            _column = { field, header: setting.lable, dataType, editable: setting.readOnly, style: { minWidth: columnWidth, maxWidth: columnWidth } };
        }
        if (dataType === 'number') {
          const fractionDigits = getFormat(setting);
          if (_column.inputProps) {
            // _column.inputProps.minFractionDigits = fractionDigits;
            // _column.inputProps.maxFractionDigits = fractionDigits;
          } else {
            _column.inputProps = {
              minFractionDigits: fractionDigits,
              maxFractionDigits: fractionDigits
            };
          }
          if (field === 'discountRate') {
            _column.inputProps.min = 0;
            _column.inputProps.max = parseFloat('99.'.padEnd(_column.inputProps.maxFractionDigits + 3, '9'));
          }

        }
        _column.maxLength = setting.maxLength;
        _columns.push(_column);
      }
      _columns.push({
        field: `formulaType`, header: 'Cách tính', dataType: 'dropdown', editable: true, style: { minWidth: '120px', maxWidth: '120px' },
        inputProps: { options: formulaTypes }
      });

      _blankItem[InvoiceField.property] = [4, 5, 6].includes(props.registerInvoice.typeCompany) ? 5 : 1;
      _blankItem[InvoiceField.vATCode] = defaultTax;

      setColumns(_columns);
      setBlankItem(_blankItem);
    }
  }, [invoiceGroupSetting, formulaTypes, products, units, taxes, currencyCode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (blankItem && Object.keys(blankItem).length) {
      if (invoiceDetail && invoiceDetail.length === 0) {
        addItem();
      }
    }
  }, [blankItem, invoiceDetail]); // eslint-disable-line react-hooks/exhaustive-deps

  const setInvoiceDetail = (items) => {
    patchItem(code, 'invoiceDetail', items);
  }

  const onCellChange = (rowData, column, newValue) => {
    const _items = [...invoiceDetail];
    for (const _item of _items) {
      if (_item._id === rowData._id) {
        _item[column.field] = newValue;
        onewayCalc = {};

        switch (column.field) {
          case InvoiceField.ProductCode:
            if (newValue && newValue.id) {
              _item[InvoiceField.ProductName] = newValue.name;
              _item[InvoiceField.UnitCode] = newValue.unit;
              _item[InvoiceField.UnitPrice] = newValue.price;
              startCalc(_item, InvoiceField.UnitPrice);
              _item[InvoiceField.vATCode] = null;
              for (const t of taxes) {
                if (t.code === newValue.taxCode) {
                  _item[InvoiceField.vATCode] = t;
                  startCalc(_item, InvoiceField.vATCode);
                  break;
                }
              }
            }
            break;
          case InvoiceField.OrdinalNumber:
            _item['ordinalNumberManual'] = true;
            break;
          case InvoiceField.property:
            if (newValue === 4) {
              _item[InvoiceField.vATCode] = null;
              _item['formulaType'] = null;
            }

            if (!_item['ordinalNumberManual']) {
              _item.isShowOrder = newValue !== 4;
            }

            _item['frameNumber'] = null;
            _item['engineNumber'] = null;
            _item['vehicleRegistrationNumber'] = null;
            _item['senderName'] = null;
            _item['senderAddress'] = null;
            _item['senderTaxCode'] = null;
            _item['senderIdentifier'] = null;
            break;
        }

        startCalc(_item, column.field);
      }
    }
    refreshItems(_items);
    setInvoiceDetail(_items);
  }

  const { render: renderDataTable, selectedItem, setSelectedItem, } = useCellEditing({
    dataKey: '_id',
    columns,
    items: virtualItems,
    onCellChange,
    onRowReorder: event => {
      refreshItems(event.value);
      setInvoiceDetail(event.value);
    },
    typeCompany: props.registerInvoice.typeCompany
  });

  const hasParams = (formula, group, field) => {
    if (formula.group === code && formula.fromFe) {
      for (let entry of JSON.parse(formula.fromFe)) {
        if (entry.type === 'parameter' && entry.groupTypeCode === group && entry.fieldName === field) {
          return true;
        }
      }
    }
    return false;
  }

  const startCalc = (_item, field) => {
    if (!onewayCalc[field]) {
      onewayCalc[field] = 0;
    }
    if (onewayCalc[field] < 50) {
      onewayCalc[field]++;

      for (const formula of formulas) {
        if ((hasParams(formula, code, field) || field === 'formulaType')
          && formula.group === code && (formula.type == null || formula.type === _item[`formulaType`])) {
          try {

            const ROUND = a => {
              for (const setting of invoiceGroupSetting[code].settings) {
                if (setting.fieldName === formula.value.replace(`${code}.`, '')) {
                  const fractionDigits = getFormat(setting);
                  a = parseFloat(parseFloat(a).toFixed(fractionDigits));
                }
              }
              return a;
            }

            let statement = '';
            for (let entry of JSON.parse(formula.fromFe)) {
              if (entry.type === 'parameter') {
                switch (entry.fieldName) {
                  case InvoiceField.vATCode:
                    let taxValue = 0;
                    if (_item[entry.fieldName] && _item[entry.fieldName].taxValue) {
                      taxValue = _item[entry.fieldName].taxValue;
                    }
                    statement += `(${taxValue})`;
                    break;
                  default:
                    statement += `(${_item[entry.fieldName] || 0})`;
                }
              } else {
                statement += entry.value;
              }
            }
            // console.log(formula, statement);
            // eslint-disable-next-line no-eval
            let result = eval(statement);
            if (typeof result === 'number') {
              if (!Number.isFinite(result) || Number.isNaN(result)) {
                result = 0;
              }
              if (`${result}`.length > 2 && `${result}`.split('.').length) {
                result = 1 * result.toPrecision(`${result}`.split('.')[0].length + 7);
              }
              _item[formula.value.replace(`${code}.`, '')] = result;
              startCalc(_item, formula.value.replace(`${code}.`, ''));
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    }
  }

  const refreshItems = (_items) => {
    let orders = 0;
    let index = 0;
    for (const i of _items) {
      if (i.isShowOrder) {
        index++;
      }
      if (!i.ordinalNumberManual) {
        if (i.isShowOrder) {
          i[InvoiceField.OrdinalNumber] = index;
        } else {
          i[InvoiceField.OrdinalNumber] = null;
        }
      }
      orders++;
      i[InvoiceField.orders] = orders;
    }
  }

  const addItem = () => {
    const _items = [...invoiceDetail];
    _items.push(Object.assign({ _id: `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}` }, blankItem));
    refreshItems(_items);
    setInvoiceDetail(_items);
  }

  const deleteItem = () => {
    if (selectedItem) {
      const _items = invoiceDetail.filter((f) => f._id !== selectedItem._id);
      refreshItems(_items);
      setInvoiceDetail(_items);
      setSelectedItem(null);
    }
  }

  const copyItem = () => {
    if (selectedItem) {
      const _items = [...invoiceDetail];
      const clone = Object.assign({}, selectedItem);
      _items.push(Object.assign(clone, { _id: `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}` }));
      refreshItems(_items);
      setInvoiceDetail(_items);
    }
  }

  const insertItem = () => {
    if (selectedItem) {
      const _items = [];
      invoiceDetail?.forEach(detail => {
        if (detail._id === selectedItem._id) {
          _items.push(Object.assign({ _id: `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}` }, blankItem));
          _items.push(detail);
        } else {
          _items.push(detail);
        }
      });
      refreshItems(_items);
      setInvoiceDetail(_items);
    }
  }

  const [display, setDisplay] = useState(false);
  const [selectableItems, setSelectableItems] = useState(null);
  const [selectedItems, setSelectedItems] = useState(null);
  const [filters] = useState({
    'productCode': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'productName': { value: null, matchMode: FilterMatchMode.CONTAINS }
  });

  const cellBody = (rowData, field) => {
    const fm = getFormat();
    const options = {
      minimumFractionDigits: fm,
      maximumFractionDigits: fm
    }
    return FormatDisplay.number(rowData[field], options);
  }

  const showSelectableItems = () => {
    const _selectableItems = [];
    props.relatedInvoiceDetail.forEach(r => {
      let add = true;
      invoiceDetail.forEach(d => {
        if (d.id === r.id) {
          add = false;
        }
      });
      if (add) {
        _selectableItems.push(r);
      }
    });
    setSelectableItems(_selectableItems);
    setSelectedItems(null);
    setDisplay(true);
  }

  const selectProducts = () => {
    if (selectedItems && selectedItems.length) {
      const _items = [];
      invoiceDetail.forEach(i => {
        if (i[InvoiceField.ProductName]) {
          _items.push(i);
        }
      });
      selectedItems.forEach((selectedItem, index) => {
        selectedItem._id = `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`;
        _items.push(Object.assign({}, selectedItem));
      });
      refreshItems(_items);
      setInvoiceDetail(_items);
      setDisplay(false);
    }
  }

  const { renderImExExcel, showImportDialog } = useImExExcel({
    exportTemplate: () => {
      return InvoiceService.downloadExcelDetail(registerInvoiceId);
    },
    exportExcel: () => {
      return InvoiceService.downloadExcelDetail(registerInvoiceId);
    },
    exportExcelFileName: 'danh-sach-hang-hoa',
    importExcel: (data) => {
      return InvoiceService.uploadExcelDetail(registerInvoiceId, data);
    },
    reloadLazyData: (result) => {
      if (result && result.length) {
        const _items = [];
        result.forEach((_item, index) => {
          _item._id = `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`;
          _item.formulaType = formulaTypes[0].value;

          for (const t of taxes) {
            if (t.code === _item.vatCode) {
              _item[InvoiceField.vATCode] = t;
              break;
            }
          }

          _items.push(Object.assign({}, _item));
        });
        refreshItems(_items);
        setInvoiceDetail(_items);
      }
    }
  });

  const template: any = {
    layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport',
    CurrentPageReport: (options) => {
      return `${options.first} - ${options.last} trong ${options.totalRecords} bản ghi`;
    }
  }

  useEffect(() => {
    window['preventToolbarShortcut'] = true;
    const onKeydown = event => {
      if (event && event.which) {
        switch (event.which) {
          case 118:
            copyItem();
            event.preventDefault();
            break;
          case 119:
            deleteItem();
            event.preventDefault();
            break;
          case 120:
            addItem();
            event.preventDefault();
            break;
          case 45:
            insertItem();
            event.preventDefault();
            break;
        }
      }
    }
    window.addEventListener('keydown', onKeydown);
    return () => {
      window.removeEventListener('keydown', onKeydown);
      window['preventToolbarShortcut'] = false;
    };
  }, [invoiceDetail, selectedItem]);

  if (invoiceGroupSetting && invoiceGroupSetting[code] && invoiceGroupSetting[code].settings) {
    return (
      <Fragment>
        <div className="mb-1">
          <Button icon="pi pi-plus" label="Thêm dòng (F9)" className="p-button-outlined p-button-sm mr-2" onClick={addItem} />
          <Button icon="pi pi-trash" label="Xoá dòng (F8)" className="p-button-outlined p-button-danger p-button-sm mr-2" onClick={deleteItem}
            disabled={!selectedItem} />
          <Button icon="pi pi-copy" label="Sao chép (F7)" className="p-button-outlined p-button-success p-button-sm mr-2" onClick={copyItem}
            disabled={!selectedItem} />
          <Button icon="pi pi-sign-in" label="Chèn dòng (Ins)" className="p-button-outlined p-button-info p-button-sm mr-2" onClick={insertItem}
            disabled={!selectedItem} />
          {([2, 3].includes(props.invoiceStatus) && props.relatedInvoiceDetail) &&
            <Fragment>
              <Button icon="pi pi-plus" label="Chọn hàng hoá" className="p-button-outlined p-button-help p-button-sm mr-2" onClick={showSelectableItems} />
              <Dialog header={`Chọn mặt hàng cần thay thế`} visible={display} style={{ width: '80vw' }} onHide={() => setDisplay(false)}>
                <DataTable value={selectableItems} selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                  showGridlines stripedRows size="small" responsiveLayout="scroll"
                  scrollable scrollHeight="flex"
                  dataKey="id" filters={filters} filterDisplay="row">
                  <Column selectionMode="multiple" style={{ minWidth: '3em', maxWidth: '3rem', justifyContent: 'center' }}></Column>
                  <Column field="ordinalNumber" header="STT" style={{ minWidth: '4rem', maxWidth: '4rem', justifyContent: 'center' }}></Column>
                  <Column field="productCode" header="Mã hàng" filter showFilterMenu={false} style={{ minWidth: '4rem' }}></Column>
                  <Column field="productName" header="Tên hàng" filter showFilterMenu={false} style={{ minWidth: '4rem' }}></Column>
                  <Column field="unitCode" header="Đơn vị tính" style={{ minWidth: '7rem', maxWidth: '7rem' }}></Column>
                  <Column field="quantity" header="Số lượng" style={{ minWidth: '7rem', maxWidth: '7rem', justifyContent: 'end' }}
                    body={(rowData) => cellBody(rowData, 'quantity')}></Column>
                  <Column field="amount" header="Đơn giá" style={{ minWidth: '7rem', maxWidth: '7rem', justifyContent: 'end' }}
                    body={(rowData) => cellBody(rowData, 'amount')}></Column>
                  <Column field="amountWithoutVAT" header="Thành tiền" style={{ minWidth: '8rem', maxWidth: '8rem', justifyContent: 'end' }}
                    body={(rowData) => cellBody(rowData, 'amountWithoutVAT')}></Column>
                  <Column field="vatName" header="Thuế suất" style={{ minWidth: '7rem', maxWidth: '7rem', justifyContent: 'center' }}></Column>
                </DataTable>
                <div className="flex justify-content-end mt-3">
                  <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm" />
                  <Button label="Đồng ý" icon="pi pi-check" onClick={selectProducts} className="p-button-sm" />
                </div>
              </Dialog>
            </Fragment>
          }
          <Button icon="pi pi-file-excel" label="Nhận Excel chi tiết" className="p-button-outlined p-button-help p-button-sm mr-2" onClick={showImportDialog} />
          {totalRecords > 0 &&
            <div className="inline-flex">
              <Paginator first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} className="p-paginator-sm p-0 pr-2"
                template={template} pageLinkSize={3}></Paginator>
            </div>
          }
        </div>
        {renderDataTable()}
        {renderDialogCrupProduct()}
        {renderDialogCrupUnit()}
        {renderImExExcel()}
      </Fragment>
    );
  } else {
    return (
      <div />
    );
  }

}